// extracted by mini-css-extract-plugin
export var bottomRow = "collageStatsCallout-module--bottom-row--6064c";
export var buttons = "collageStatsCallout-module--buttons--87da6";
export var collage = "collageStatsCallout-module--collage--19c2b";
export var collageImage = "collageStatsCallout-module--collage-image--e9fad";
export var collageRow = "collageStatsCallout-module--collage-row--069e9";
export var collageStatsCallout = "collageStatsCallout-module--collage-stats-callout--50d9c";
export var content = "collageStatsCallout-module--content--806eb";
export var description = "collageStatsCallout-module--description--e27b3";
export var eyebrow = "collageStatsCallout-module--eyebrow--7f09e";
export var headline = "collageStatsCallout-module--headline--55d87";
export var primaryButton = "collageStatsCallout-module--primary-button--01bdb";
export var secondaryButton = "collageStatsCallout-module--secondary-button--88a7c";
export var stat = "collageStatsCallout-module--stat--5a44d";
export var statLabel = "collageStatsCallout-module--stat-label--2cec4";
export var statValue = "collageStatsCallout-module--stat-value--e2b82";
export var stats = "collageStatsCallout-module--stats--5a358";
export var topRow = "collageStatsCallout-module--top-row--abcb9";